import React, { useContext, useEffect } from "react";
import DmeoDigitalPerformanceEvolutionChart from "../../../components/Charts/Dmeo/DmeoDigitalPerformanceEvolutionChart";
import { ThemeContext } from "../../../context";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getDmeoDigitalPerformanceEvolution } from "../../../api/dmeoApi";

const DigitalPerformanceEvolutionTile = withRouter((props: RouteComponentProps) => {
  const { history } = props;

  const { theme } = useContext(ThemeContext);

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["digitalPerformanceEvolutionData", history.location.search],
    queryFn: getDmeoDigitalPerformanceEvolution,
    enabled: false,
  });

  useEffect(() => {
    refetch();
  }, [history.location.search]);

  return (
    <div className="tile">
      <div className="tile-header">Digital Performance Evolution</div>
      <div className="tile-content">
        <DmeoDigitalPerformanceEvolutionChart
          chartId="digitalPerformanceEvolutionChart"
          data={data?.data ? data.data : []}
          seriesList={data?.series ? data.series : []}
          isLoading={isFetching}
          theme={theme}
        />
      </div>
    </div>
  );
});

export default DigitalPerformanceEvolutionTile;
